module.exports = __webpack_public_path__ + "static/hermit-69f4a5f7d2d8e0ea8162879098352559.jpg";